<template>
  <div>
    <v-app-bar dark dense hide-on-scroll>
      <v-toolbar-title>{{appTitle}}</v-toolbar-title>

      <div class="flex-grow-1"></div>

      <v-btn to="/">
        <v-icon>mdi-home</v-icon>
      </v-btn>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  name: "Toolbar",
  data() {
    return {
      appTitle: "Buggy by Max"

      /*drawer: false,
            items: [
                { title: 'Menu' },
                { title: 'Sign In' },
                { title: 'Join' }
            ]
            */
    };
  }
};
</script>